/*
  满赠：购物车自动加入/移除赠品。

  价格不归这里管——赠品变 $0 是 Shopify 原生「买X送Y」自动折扣（procurement-app 同步）。
  这里只负责让购物车里"该有的赠品在、不该有的不在"：
    - 读 snippets/gift-cart-notice.liquid 输出的状态（[data-gift-state]，每次购物车刷新都是服务端重新算的）；
    - 达标且没送完的档位 → 加入赠品（带 _gift 属性 + 可见的 Freebies 属性，结账/订单/邮件都能看到）；
    - 不再达标/活动结束的赠品行 → 移除；赠品数量不对 → 改回应有件数（阶梯每档 1 件，单档可重复按门槛倍数）；
    - 赠品不支持手动删除（购物车里不显示 Remove），达标就一定在；
    - 加进来的赠品如果没被原生折扣免成 0 元，立刻撤掉（绝不让顾客为赠品付钱）。
  触发：cart-form.js 每次重建购物车后派发 gift:cart-rendered；页面加载时也跑一次。
  改完购物车后派发 cart:build 让主题重新渲染，重新渲染又会触发一次检查（这时应该已经无事可做）。
*/
(function () {
  if (window.__moeGiftCampaign) return;
  window.__moeGiftCampaign = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var pending = false;
  var runLog = [];
  var failedVariants = {};

  function readState() {
    var nodes = document.querySelectorAll('[data-gift-state]');
    if (!nodes.length) return null;
    try {
      return JSON.parse(nodes[nodes.length - 1].textContent);
    } catch (e) {
      return null;
    }
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Moe-Gift': '1' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    });
  }

  function plan(state) {
    var wanted = {};
    var tierInfo = {};
    (state.campaigns || []).forEach(function (campaign) {
      (campaign.tiers || []).forEach(function (tier) {
        var marker = campaign.id + ':' + tier.id;
        tierInfo[marker] = { campaign: campaign, tier: tier };
        if (tier.r && !tier.s && !failedVariants[String(tier.v)]) {
          wanted[marker] = tier;
        }
      });
    });

    var present = {};
    var updates = {};
    (state.lines || []).forEach(function (line) {
      var info = tierInfo[line.g];
      var stillValid = info && info.tier.r && !info.tier.s && String(info.tier.v) === String(line.v);
      if (!stillValid || present[line.g]) {
        updates[line.k] = 0;
        return;
      }
      present[line.g] = line;
      // 应有件数：阶梯每档 1 件；单档可重复 = 门槛倍数（状态里的 n）
      var wantQty = Number(info.tier.n) || 1;
      if (Number(line.q) !== wantQty) {
        updates[line.k] = wantQty;
      } else if (line.f === false) {
        // 主题算达标、但原生折扣没把它免成 0 元（资格合集还没同步到新商品等）：撤掉，
        // 本页面不再重试，避免顾客为"赠品"付原价
        updates[line.k] = 0;
        failedVariants[String(line.v)] = true;
        delete present[line.g];
        delete wanted[line.g];
      }
    });

    var adds = [];
    Object.keys(wanted).forEach(function (marker) {
      if (present[marker]) return;
      var tier = wanted[marker];
      adds.push({
        id: Number(tier.v),
        quantity: Number(tier.n) || 1,
        properties: { Freebies: tier.l, _gift: marker }
      });
    });
    return { updates: updates, adds: adds };
  }

  // 加不进购物车的赠品（没发布到网店/缺货，cart/add.js 返回 422）：在进度条那一档标出来，别让顾客以为赠品会来
  function markUnavailable(state) {
    document.querySelectorAll('[data-gift-cart-notice] [data-gift-tier]').forEach(function (row) {
      var tierId = row.getAttribute('data-gift-tier');
      var tier = null;
      (state.campaigns || []).forEach(function (c) {
        (c.tiers || []).forEach(function (t) { if (t.id === tierId) tier = t; });
      });
      if (!tier || !tier.r || !failedVariants[String(tier.v)] || row.querySelector('[data-gift-unavailable]')) return;
      var status = row.querySelector('[data-gift-tier-status]');
      if (status) {
        status.textContent = ' · unavailable';
        status.setAttribute('data-gift-unavailable', '1');
      }
    });
  }

  function tooManyRuns() {
    var now = Date.now();
    runLog = runLog.filter(function (t) { return now - t < 10000; });
    if (runLog.length >= 4) return true;
    runLog.push(now);
    return false;
  }

  function reconcile() {
    if (busy) {
      pending = true;
      return;
    }
    var state = readState();
    if (!state) return;
    var todo = plan(state);
    markUnavailable(state);
    var hasUpdates = Object.keys(todo.updates).length > 0;
    if (!hasUpdates && !todo.adds.length) return;
    if (tooManyRuns()) return;

    busy = true;
    var chain = Promise.resolve();
    if (hasUpdates) chain = chain.then(function () { return post('cart/update.js', { updates: todo.updates }); });
    if (todo.adds.length) {
      chain = chain.then(function () {
        return post('cart/add.js', { items: todo.adds }).then(function (res) {
          if (res.ok || todo.adds.length === 1) {
            if (!res.ok) failedVariants[String(todo.adds[0].id)] = true;
            return;
          }
          // 一次加多件有一件失败（缺货等）会整批失败，逐个重试并记住失败的变体，避免反复重试
          return todo.adds.reduce(function (p, item) {
            return p.then(function () {
              return post('cart/add.js', { items: [item] }).then(function (single) {
                if (!single.ok) failedVariants[String(item.id)] = true;
              });
            });
          }, Promise.resolve());
        });
      });
    }
    chain
      .catch(function (error) {
        console.warn('[gift-campaign] 更新购物车赠品失败', error);
      })
      .then(function () {
        busy = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (pending) {
          pending = false;
        }
      });
  }

  document.addEventListener('gift:cart-rendered', function () {
    setTimeout(reconcile, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
